var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.children
    ? _c(
        "router-link",
        {
          class: ["navbar-item", _vm.gtmtag],
          attrs: {
            "active-class": "navbar-item-active",
            to: _vm.item.path,
            "data-test": "nav-" + _vm.item.title.toLowerCase(),
          },
        },
        [
          _c("span", { class: { "badge-holder": _vm.item.badge } }, [
            _vm.item.badge
              ? _c("span", { staticClass: "badge" }, [
                  _vm._v(_vm._s(_vm.item.badge)),
                ])
              : _vm._e(),
            _vm._v(" " + _vm._s(_vm.item.title)),
          ]),
        ]
      )
    : _c("div", { staticClass: "navbar-item has-dropdown is-hoverable" }, [
        _c("a", { staticClass: "navbar-link" }, [
          _vm._v(_vm._s(_vm.item.title)),
        ]),
        _c(
          "div",
          { staticClass: "navbar-dropdown" },
          _vm._l(_vm.children, function (child, index) {
            return _c(
              "router-link",
              {
                key: index,
                staticClass: "navbar-item",
                attrs: { "active-class": "navbar-item-active", to: child.path },
              },
              [_vm._v(_vm._s(child.title))]
            )
          }),
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }